import React, { useContext, useEffect, useRef, useState } from 'react';
import { AlertWrapper, ModalWraper } from '../UI/styledConstants';
import IconClose from '../../assets/images/IconClose';
import { rPaySendTxnOtp, sendmoneyPreakup } from '../../utils/api';
import { clickOutside, getLocation, isEmpty, overLayers } from '../../utils/common';
import Loader from '../UI/Loader/Loader';
import { GlobleContaxt } from '../../Context/GlobleContaxt';

const transferOptions = [
	{
		label: 'IMPS',
		value: 'IMPS',
	},
	{
		label: 'NEFT',
		value: 'NEFT',
	},
	{
		label: 'RTGS',
		value: 'RTGS',
	},
];

export default function PayModal({
	modalData = null,
	mobileNumber = '',
	onCloseModal = () => {},
	verifySenderStatus = () => {},
	referenceKey="",
	setModal,
	sendAmount
}) {
	const [amount, setAmount] = useState('');
	const [mode, setMode] = useState('');
	const [loding, setLoding] = useState(false);
	const [pageMsg, setPageMsg] = useState({});
	const [changesCharges, setChangesChares] = useState({});
	const [changesValue, setChangesValue] = useState("");
	const [changesLoader, setChangesLoader] = useState(false);

	const numberReg = /^[0-9]+$/;
	const { setRefresh, refresh, geolocation, setGeolocation ,setAlert} = useContext(GlobleContaxt);
	
	const onSubmit = () => {
		if (isEmpty(amount)) {
			setPageMsg({ type: 'error', text: 'Please enter amount' });
			return;
		} else if (isEmpty(mode)) {
			setPageMsg({ type: 'error', text: 'Please select mode' });
			return;
		}

		if (isEmpty(geolocation?.latitude)) {
			setAlert({ type: 'warning', msg: 'Please allow access to your location'});
			getLocation().then((position) => {
				setGeolocation(position);
			});

			return;
		}

		
	
		const params = {
		
			senderMobile:mobileNumber,
            beneId:modalData?.beneId,
            beneName:modalData?.name,
            bankId:modalData?.bankId,
            bankName:modalData?.bankName,
            accountNo:modalData?.accountNo,
            ifsc:modalData?.ifsc,
            securityKey:"",
            amount:amount,
			lattitude:geolocation?.latitude.toFixed(4),
			longitude:geolocation.longitude.toFixed(4),
            transMode:mode ,
            refFerenceID:referenceKey
		};
 
		if(amount > 5000 ){
			sendAmount(params)
			return
		}

		setLoding(true);
		setAmount('');
		setMode('');
		rPaySendTxnOtp(params).then((response) => {
			setLoding(false);
			if (response?.success) {
				if(response?.data?.statuscode < 0){
					setAlert({ type: 'error', msg: response?.data?.msg });
					return
				}
				setAlert({ type: 'success', msg: response?.msg });
				 setModal({ name: 'VERIFY_TRANSACTION_OTP_MODAL', modalData: response?.data,params:params });
				// setModal({ name: 'TRANSACTION_SUCCESS_MODAL', modalData: response?.data });
				setRefresh(!refresh);
			} else {

				if (response?.errorCodeList.length > 0) {
					setAlert({ type: 'error', msg: response?.errorCodeList[0] });
				}else{
					setAlert({ type: 'error', msg: response?.msg });
				}
			}
			
		});
	};
const getPriceBreckup = () =>{
	const params = {
		amount: amount,
    route: mode,
    serviceType: "MONEY_TRANSFER"
	}
	setChangesLoader(true)
	sendmoneyPreakup(params).then((response) => {
		setChangesLoader(false);
		setLoding(false);
		if (response?.success) {
			const value = "₹"+ response.data.charge || "";
			setChangesValue(value);
			
		} else {
			setChangesValue(response?.msg);
			
		}
		
	});
}
useEffect(() =>{
	setChangesChares("");
	setChangesValue("");
},[amount,mode])
const showCharges =(e) =>{
	
	setChangesChares(e.target.value);
	getPriceBreckup();
}


	const boxRef = useRef(null);
	useEffect(() =>{
		overLayers(true);
		clickOutside(true,boxRef,onCloseModal);
	
		return(() =>{
			overLayers(false)
			clickOutside(false,boxRef,onCloseModal);
		})
	
	},[]);


	return (
		<ModalWraper width="600px">
			<div className="modal pay-modal" ref={boxRef}>
				<div className="modal-header">
					<div className="modal-title">Make Payment</div>
					<div className="modal-close" onClick={onCloseModal}>
						<IconClose />
					</div>
				</div>
				<div className="modal-body">
					<div className="pay-modal-form">
						{!isEmpty(pageMsg) && (
							<AlertWrapper className={pageMsg?.type}>
								<span className="close" onClick={() => setPageMsg({})}>
									×
								</span>
								{pageMsg?.text}
							</AlertWrapper>
						)}

						<div className="row">
							<div className="col-6">
								<div className="form-field">
									<input type="text" name="beneficiaryName" placeholder="Beneficiary Name" value={modalData?.name} disabled />
								</div>
							</div>
							<div className="col-6">
								<div className="form-field">
									<input type="text" name="bankName" placeholder="Bank Name" value={modalData?.bankName} disabled />
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-6">
								<div className="form-field">
									<input type="text" name="ifscCode" placeholder="IFSC Code" value={modalData?.ifsc} disabled />
								</div>
							</div>
							<div className="col-6">
								<div className="form-field">
									<input type="text" name="accountNumber" placeholder="Account Number" value={modalData?.accountNo} disabled />
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-6">
								<div className="form-field">
									<input
										type="text"
										name="amount"
										placeholder="Amount"
										inputMode="numeric"
										value={amount}
										onChange={(e) => (!numberReg.test(e.target.value) && e.target.value ? '' : setAmount(e.target.value))}
									/>
								</div>
							</div>
							<div className="col-6">
								<div className="form-field">
									<select className="item-select mobile-operator" placeholder="Operator" name="operatorCode" value={mode} onChange={(e) => setMode(e.target.value)}>
										<option value="">Transfer Mode</option>
										{transferOptions.map((option, i) => {
											return (
												<option key={i} value={option?.value}>
													{option?.label}
												</option>
											);
										})}
									</select>
								</div>
							</div>
						</div>

						{/* {!isEmpty(amount) && !isEmpty(mode) &&<div className="form-field checkChargesBox">
							<div className='flex'>
							<input id="checkchges" value={"charges"} name="button" type="radio" onChange={showCharges} checked={changesCharges ==="charges"} />
							<div class="circle"></div> 
                             <label htmlFor="checkchges" class="overlay">
                            
                              <span class="text">View Charges</span>  
                              </label>
							</div>
							{changesValue &&<p style={{fontWeight:700}}>
                                {changesValue}
							</p>}
							{
								changesLoader && <p>Loading...</p>
							}
						</div>} */}
					</div>
				</div>
				<div className="modal-footer">
					<button className="button-solid" onClick={onSubmit}>
						PAY NOW
					</button>
				</div>
				{loding && <Loader />}
			</div>
		</ModalWraper>
	);
}
